import _ from 'underscore';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'vend... Remove this comment to see the full error message
import createStore from 'vendor/cnpm/fluxible.v0-4/addons/createStore';

import {
  DeleteState,
  InviteState,
  ResendInvitationState,
  SearchState,
} from 'bundles/groups-common/constants/MemberConstants';
import UploadState from 'bundles/groups-common/constants/UploadState';

const InvitationStore = createStore({
  storeName: 'InvitationStore',

  initialize() {
    this.reset();
  },

  getUploadStatus() {
    return this.uploadStatus;
  },

  getResendAllInviteStatus() {
    return this.resendAllInviteStatus;
  },

  getResendInviteStatus() {
    return this.resendInviteStatus;
  },

  getIndividualInviteStatus() {
    return this.individualInviteStatus;
  },

  getDeleteInviteStatus() {
    return this.deleteInviteStatus;
  },

  getInvitations() {
    return this.invitations;
  },

  getTotalCount() {
    return this.totalCount;
  },

  getInviteState() {
    return this.inviteState;
  },

  getSearchStatus() {
    return this.searchStatus;
  },

  reset() {
    this.invitations = null;
    this.uploadStatus = {
      state: UploadState.IDLE,
    };
    this.resendInviteStatus = ResendInvitationState.IDLE;
    this.resendAllInviteStatus = ResendInvitationState.IDLE;
    this.deleteInviteStatus = DeleteState.IDLE;
    this.individualInviteStatus = InviteState.IDLE;
    this.inviteState = InviteState.IDLE;
    this.searchStatus = {
      state: SearchState.IDLE,
      items: null,
    };
  },
});

InvitationStore.handlers = {
  UPLOAD_INVITATIONS_STARTED() {
    this.uploadStatus = {
      state: UploadState.UPLOADING,
    };
    this.emitChange();
  },

  UPLOAD_INVITATIONS_CANCELLED() {
    this.uploadStatus = {
      state: UploadState.IDLE,
    };
    this.emitChange();
  },

  UPLOAD_INVITATIONS_PREVIEW({ invitationCount }: $TSFixMe) {
    this.uploadStatus = {
      state: UploadState.PREVIEW,
      invitationCount,
    };
    this.emitChange();
  },

  UPLOAD_INVITATIONS_SUCCEEDED({ invitationCount }: $TSFixMe) {
    this.uploadStatus = {
      state: UploadState.SUCCESS,
      invitationCount,
    };
    this.emitChange();
  },

  UPLOAD_INVITATIONS_FAILED() {
    this.uploadStatus = {
      state: UploadState.ERROR,
    };
    this.emitChange();
  },

  USER_INVITED({ name, email }: $TSFixMe) {},

  SEARCH_LEARNERS_STARTED() {
    this.searchStatus = {
      state: SearchState.SEARCHING,
    };
    this.emitChange();
  },

  SEARCH_LEARNERS_SUCCEEDED({ learners }: $TSFixMe) {
    // normalize items for search
    const items = _(learners).map((item) => {
      return _(item).extend({
        email: item.invitee.email,
        fullName: item.invitee.name,
      });
    });

    this.searchStatus = {
      state: SearchState.SUCCEEDED,
      items,
    };
    this.emitChange();
  },

  SEARCH_LEARNERS_FAILED() {
    this.searchStatus = {
      state: SearchState.FAILED,
    };
    this.emitChange();
  },

  SEARCH_STATUS_RESET() {
    this.searchStatus = {
      state: SearchState.IDLE,
    };
    this.emitChange();
  },

  RECEIVED_INVITATIONS({ invitations, totalCount }: $TSFixMe) {
    this.invitations = invitations;
    this.totalCount = totalCount || 0;
    this.emitChange();
  },

  DELETE_INVITATION({ invitationId }: $TSFixMe) {
    // @ts-expect-error ts-migrate(7006): Parameter invitation implicitly has an any type
    this.invitations = _(this.invitations).reject((invitation) => invitation.id === invitationId);
    this.emitChange();
  },

  INVITATIONS_RESET() {
    this.invitations = null;
    this.inviteState = InviteState.IDLE;
    this.emitChange();
  },

  SEND_INVITATIONS_STARTED() {
    this.inviteState = InviteState.SENDING;
    this.emitChange();
  },

  SEND_INVITATIONS_SUCCEEDED() {
    this.inviteState = InviteState.SENT;
    this.emitChange();
  },

  SEND_INVITATIONS_FAILED() {
    this.inviteState = InviteState.FAILED;
    this.emitChange();
  },

  RESEND_ALL_INVITATIONS_STARTED() {
    this.resendAllInviteStatus = ResendInvitationState.SENDING;
    this.emitChange();
  },

  RESEND_ALL_INVITATIONS_SENT() {
    this.resendAllInviteStatus = ResendInvitationState.SENT;
    this.emitChange();
  },

  RESEND_ALL_INVITATIONS_FAILDED() {
    this.resendAllInviteStatus = ResendInvitationState.FAILED;
    this.emitChange();
  },

  RESEND_ALL_INVITATIONS_RESET() {
    this.resendAllInviteStatus = ResendInvitationState.IDLE;
    this.emitChange();
  },

  RESEND_INVITATIONS_STARTED() {
    this.resendInviteStatus = ResendInvitationState.SENDING;
    this.emitChange();
  },

  RESEND_INVITATIONS_SENT() {
    this.resendInviteStatus = ResendInvitationState.SENT;
    this.emitChange();
  },

  RESEND_INVITATIONS_FAILDED() {
    this.resendInviteStatus = ResendInvitationState.FAILED;
    this.emitChange();
  },

  RESEND_INVITATIONS_RESET() {
    this.resendInviteStatus = ResendInvitationState.IDLE;
    this.emitChange();
  },

  INDIVIDUAL_INVITATION_STARTED() {
    this.individualInviteStatus = InviteState.SENDING;
    this.emitChange();
  },

  INDIVIDUAL_INVITATION_SENT() {
    this.individualInviteStatus = InviteState.SENT;
    this.emitChange();
  },

  INDIVIDUAL_INVITATION_FAILED() {
    this.individualInviteStatus = InviteState.FAILED;
    this.emitChange();
  },

  INDIVIDUAL_INVITATION_RESET() {
    this.individualInviteStatus = InviteState.IDLE;
    this.emitChange();
  },

  DELETE_INVITATIONS_STARTED() {
    this.deleteInviteStatus = DeleteState.DELETING;
    this.emitChange();
  },

  DELETE_INVITATIONS_FINISHED() {
    this.deleteInviteStatus = DeleteState.DELETED;
    this.emitChange();
  },

  DELETE_INVITATIONS_FAILED() {
    this.deleteInviteStatus = DeleteState.FAILED;
    this.emitChange();
  },

  DELETE_INVITATIONS_RESET() {
    this.deleteInviteStatus = DeleteState.IDLE;
    this.emitChange();
  },
};

export default InvitationStore;
